"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const core_1 = require("companion-app-components/utils/core");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const QMenu_1 = __importDefault(require("components/QMenu"));
const types_1 = require("data/accountBalances/types");
const BalanceSelectMenu = ({ menuIconButtonSize, classes }) => {
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const handleAccountBarBalanceMenu = (balType, groupId) => {
        if (groupId === 'balDisplay') {
            setDatasetPreference({ accountBarBalanceType: balType });
            // Tracking what got changed
            core_1.tracker.track(core_1.tracker.events.accountBalanceChange, {
                type: 'accountList',
                changedTo: balType,
            });
        }
        else if (groupId === 'showCents') {
            setDatasetPreference({ accountBarShowCents: !datasetPreferences.accountBarShowCents });
        }
    };
    const { accountBarBalanceType, accountBarShowCents } = datasetPreferences;
    const menuOptions = types_1.visibleBalances.map((balObj) => ({ label: balObj.label, value: balObj.value }));
    menuOptions[menuOptions.length - 1].divider = true;
    return (<div className={classes.balanceMenu}>
      <QMenu_1.default name="balmenu" title="Select balance type to view" options={[
            {
                label: 'Balance Display',
                groupId: 'balDisplay',
                isGroupList: true,
                selected: accountBarBalanceType,
                groupList: menuOptions,
            },
            {
                label: null,
                groupId: 'showCents',
                isGroupList: true,
                selected: accountBarShowCents ? 'showCents' : null,
                groupList: [{ label: 'Show Cents', value: 'showCents' }],
            },
        ]} onChange={handleAccountBarBalanceMenu} menuIconButtonSize={menuIconButtonSize || 'smallNoPadding'}/>
    </div>);
};
exports.default = BalanceSelectMenu;
